import { render, staticRenderFns } from "./CarteiraCadastroDepartamentosApp.vue?vue&type=template&id=f8e3423c&scoped=true"
import script from "./CarteiraCadastroDepartamentosApp.vue?vue&type=script&lang=js"
export * from "./CarteiraCadastroDepartamentosApp.vue?vue&type=script&lang=js"
import style0 from "./CarteiraCadastroDepartamentosApp.vue?vue&type=style&index=0&id=f8e3423c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e3423c",
  null
  
)

export default component.exports